import { Injectable } from '@angular/core';
import {ParentService} from '../A2-utils/ParentClass/ParentService';
import {Router} from '@angular/router';
import {Http, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import { constant } from '../../app.constants';

@Injectable()
export class FacilitiesService extends ParentService {

  constructor(private _http: Http, private route: Router) {
    super();
    // this.verifyToken(this._http, route);
  }

  /**
   * @name getFacilities
   * @description
   * @param filter
   * @param showDisabled
   */
  getFacilities(filter, showDisabled, payor?: number) {
    return this._http
      .get(
        `${constant.URL_GET_FACILITIES_NEW}${filter}&showDisabled=${showDisabled}&payorId=${payor}&showOrderingFacility=true`,
        this.getHeader())
      .map(res => res.json()).catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name getFacilityById
   * @description
   * @param id
   */
  getFacilityById(id: number) {
    return this._http
    .get(constant.URL_FACILITY + '/' + id, this.getHeader())
    .map(res => res.json());
  }

  /**
   * @name postData
   * @description
   * @param data
   */
  postData(data: any) {
    const bodyString = JSON.stringify(data);

    return this._http
      .post(constant.URL_FACILITY, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name putData
   * @description
   * @param data
   */
  putData(data: any) {
    const bodyString = JSON.stringify(data);

    return this._http
      .put(constant.URL_FACILITY, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json() || 'Server error'));
  }

  /**
   * @name deleteData
   * @description
   * @param data
   */
  deleteData(data: any) {
    return this._http
      .delete(`${constant.URL_FACILITY}/${data}`, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/facilities/facilities.service.ts